import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import TrackingPublico from './pages/TrackingPublico';
import '../src/styles/index.scss';


function Navbar() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');

  return (
    <header style={{
      background: 'var(--navy)',
      height: 60,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 28px',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
    }}>
      {/* Logo */}
      <Link to="https://www.sologt.com" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <img src="/logoSoloGT.svg" alt="SoloGT Logo" className='logo-navBar' />
        <span style={{ fontWeight: 800, fontSize: 17, color: '#fff', letterSpacing: '-0.3px' }}>
          SoloGT <span style={{ color: '#ffffff' }}>Tracking</span>
        </span>
      </Link>

      {/* Nav buttons */}
      <nav style={{ display: 'flex', gap: 6 }}>
       <a href="https://wa.link/s0c4dw" target='_blank' className='text-blanco'>Habla con un asesor</a>
       
      </nav>
    </header>
  );
}

function NavLink({ to, active, label, icon }) {
  return (
    <Link to={to} style={{
      display: 'flex', alignItems: 'center', gap: 6,
      padding: '6px 14px',
      borderRadius: 8,
      fontSize: 13,
      fontWeight: active ? 600 : 400,
      color: active ? '#00b894' : 'rgba(255,255,255,0.55)',
      background: active ? 'rgba(0,184,148,0.12)' : 'transparent',
      border: active ? '1px solid rgba(0,184,148,0.25)' : '1px solid transparent',
      transition: 'all 0.18s',
    }}>
      <span>{icon}</span> {label}
    </Link>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<TrackingPublico />} />
      </Routes>
    </BrowserRouter>
  );
}
